import qs from 'qs'
import FormValues from '../components/filters-form/types/form-values'
import { buildFilters } from './build-filters'
import { DeserializeFilters } from '../../../../../../hooks/table-pages/use-endpoint-query-parameters'

export const deserializeFilters: DeserializeFilters = filtersString => {
    const formValues = qs.parse(filtersString) as Partial<FormValues>
    return buildFilters(formValues)
}
